import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

export interface INetworkDiagramOptions {
    snapNodesToGrid: boolean;
    snapGridSize: number;
    autoCreateKinkPoints: boolean;
}

@Component
export default class NetworkDiagramOptionsDialog extends Vue {

    @Prop()
    value: INetworkDiagramOptions;

    onCancelClick() {
        this.$emit("dialogClosed", "cancel");
    }

    onOkClick() {
        this.$emit("dialogClosed", "ok", this.value);
    }

}



// WEBPACK FOOTER //
// ./ClientApp/components/network-diagram-options-dialog/network-diagram-options-dialog.ts